/**
 * Redirect to /cart after a successful Add to Cart from the product form.
 * Listens for the native Horizon 'cart:update' event (bubbles to document).
 * Skips redirect on error events and non-product-form sources (e.g. cart drawer qty changes).
 */
document.addEventListener('cart:update', (event) => {
  const data = event.detail?.data;
  if (data?.didError) return;
  if (data?.source !== 'product-form-component') return;

  window.location.href = window.Theme?.routes?.cart_url || '/cart';
});
